/* VoltGuard advertorial/product interactions for Shopify-hosted pages. */
(function () {
  'use strict';

  var config = window.VOLTGUARD_CONFIG || {};
  var isProduct = config.pageType === 'product';
  var variants = window.VOLTGUARD_VARIANTS || {};
  var cartSettings = window.VOLTGUARD_CART_SETTINGS || {};
  var googleAds = config.googleAds || {};
  var navigationPending = false;

  // Shopify Checkout returns to this page through the browser's back-forward
  // cache. Clear the previous navigation lock so a newly selected bundle can
  // start checkout again without requiring a full refresh.
  window.addEventListener('pageshow', function () {
    navigationPending = false;
    if (isProduct) updateAddToCart();
  });

  function googleSendTo(label) {
    var conversionId = String(googleAds.conversionId || '').trim();
    label = String(label || '').trim();
    if (!/^AW-\d+$/.test(conversionId) || !label) return '';
    return conversionId + '/' + label;
  }

  function navigateWithConversion(label, url) {
    if (!url || navigationPending) return;
    navigationPending = true;

    var completed = false;
    var navigate = function () {
      if (completed) return;
      completed = true;
      window.location.assign(url);
    };
    var sendTo = googleSendTo(label);

    if (!sendTo || typeof window.gtag !== 'function') {
      navigate();
      return;
    }

    window.setTimeout(navigate, 1200);
    try {
      window.gtag('event', 'conversion', {
        send_to: sendTo,
        event_callback: navigate
      });
    } catch (error) {
      navigate();
    }
  }

  function withCurrentQuery(base) {
    if (!base) return '';
    try {
      var target = new URL(base, window.location.origin);
      var current = new URLSearchParams(window.location.search);
      var targetOwnedParams = {};
      var shopifyOnlyParams = {
        view: true,
        preview_theme_id: true,
        preview_script_debug: true,
        _fd: true,
        pb: true,
        section_id: true
      };
      target.searchParams.forEach(function (value, key) {
        targetOwnedParams[key] = true;
      });
      current.forEach(function (value, key) {
        if (!shopifyOnlyParams[key] && !targetOwnedParams[key]) {
          target.searchParams.append(key, value);
        }
      });
      var query = target.searchParams.toString();
      if (target.searchParams.has('checkout') && target.searchParams.get('checkout') === '') {
        query = query.replace(/(^|&)checkout=(?=&|$)/, '$1checkout');
      }
      return target.pathname + (query ? '?' + query : '') + target.hash;
    } catch (error) {
      return base;
    }
  }

  function destination() {
    var base = isProduct ? config.checkoutUrl : config.productUrl;
    return withCurrentQuery(base);
  }

  var ctaSelector = [
    'a[href="/pages/voltguard-product"]',
    'a[href^="/pages/contact?view=voltguard-product"]',
    '.floatNewBtn',
    '.checkout-button-section',
    '.submit-section',
    '.news-sidebar3-btn',
    '.news-button-title',
    '.cb-express'
  ].join(', ');

  function closestCta(element) {
    return element && element.closest ? element.closest(ctaSelector) : null;
  }

  function prepareCtas() {
    var target = destination();
    document.querySelectorAll(ctaSelector).forEach(function (cta) {
      if (target && cta.matches('a')) {
        cta.setAttribute('href', target);
        cta.removeAttribute('target');
      }
      if (!target && !isProduct) {
        cta.classList.add('vgd-checkout-pending');
        cta.setAttribute('aria-disabled', 'true');
        cta.setAttribute('title', 'Checkout link pending');
        if (cta.matches('button')) cta.disabled = true;
        cta.querySelectorAll('button').forEach(function (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        });
      }
    });
  }

  function productRows() {
    return document.querySelectorAll('.product-row[data-vg-bundle]');
  }

  function selectedProductRow() {
    var selected = document.querySelector('.product-row[data-vg-bundle] input[name="product"]:checked');
    return selected && selected.closest('.product-row[data-vg-bundle]');
  }

  function variantIdFor(row) {
    if (!row) return '';
    var configured = variants[row.dataset.vgBundle];
    var value = configured && typeof configured === 'object' ? configured.variantId : configured;
    value = value == null ? '' : String(value).trim();
    return /^\d+$/.test(value) ? value : '';
  }

  function quantityFor(row) {
    return row ? 1 : 0;
  }

  function updateAddToCart() {
    if (!isProduct) return;
    var row = selectedProductRow();
    var ready = Boolean(row && variantIdFor(row));
    document.querySelectorAll('.checkout-button-section').forEach(function (section) {
      var button = section.querySelector('button');
      section.classList.toggle('vgd-checkout-pending', !ready);
      section.setAttribute('aria-disabled', ready ? 'false' : 'true');
      section.setAttribute('title', ready ? 'Add selected bundle' : 'Select a configured bundle');
      if (button) {
        button.disabled = !ready;
        button.setAttribute('aria-disabled', ready ? 'false' : 'true');
      }
    });
  }

  function bundleSelector() {
    var rows = productRows();
    if (!rows.length) return;
    rows.forEach(function (row) {
      var radio = row.querySelector('input[name="product"]');
      if (!radio) return;
      row.addEventListener('click', function (event) {
        rows.forEach(function (sibling) {
          sibling.classList.remove('current-item');
        });
        radio.checked = true;
        row.classList.add('current-item');
        updateAddToCart();
      });
      radio.addEventListener('change', function () {
        updateAddToCart();
      });
    });
    var selected = selectedProductRow() || document.querySelector('.product-row[data-vg-bundle="3"]');
    if (selected) {
      var selectedRadio = selected.querySelector('input[name="product"]');
      if (selectedRadio) selectedRadio.checked = true;
      selected.classList.add('current-item');
    }
  }

  document.addEventListener('click', function (event) {
    var cta = closestCta(event.target);
    if (!cta) return;
    event.preventDefault();
    event.stopPropagation();
    if (isProduct) {
      var row = selectedProductRow();
      var variantId = variantIdFor(row);
      if (!variantId) return;
      var cartUrl = '/cart/' + encodeURIComponent(variantId) + ':' + quantityFor(row);
      if (cartSettings.redirectToCheckout !== false) cartUrl += '?checkout';
      cartUrl = withCurrentQuery(cartUrl);
      navigateWithConversion(googleAds.beginCheckoutLabel, cartUrl);
      return;
    }
    var target = destination();
    if (target) navigateWithConversion(googleAds.addToCartLabel, target);
  }, true);

  function removeKlarnaBadge() {
    document.querySelectorAll('.productSecure img').forEach(function (image) {
      var source = image.getAttribute('src') || '';
      if (source.indexOf('vgd-product-ext-30bebd57f8299d4ad993bbf44a1f377e.svg') !== -1) {
        image.remove();
      }
    });
  }

  function initialize() {
    removeKlarnaBadge();
    prepareCtas();
    bundleSelector();
    updateAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
